import { ILabelDesignerTemplateDTO, ILabelDesignerTemplateViewDTO } from "../../coreapi-dto/dirs/labelDesignerTemplate";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";


interface ILabelDesignerTemplateCreate extends ILabelDesignerTemplateDTO {
}
interface ILabelDesignerTemplateUpdate extends ILabelDesignerTemplateDTO {
}

export class LabelDeisgnerTemplateRequest extends BaseDirRequest<ILabelDesignerTemplateViewDTO, ILabelDesignerTemplateDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "LabelDesignerTemplate", token, eventHandler)
    }
    
    create(body: ILabelDesignerTemplateCreate, callback: (e:CoreApiResponse<string>) => void) {
        super.create(body, callback)
    }

    update(idGlobal: string, body: ILabelDesignerTemplateUpdate, callback: (e:CoreApiResponse<null>) => void) {
        super.update(idGlobal, body, callback)
    }
}